import script from "./CurrencyList.vue?vue&type=script&lang=ts&setup=true"
export * from "./CurrencyList.vue?vue&type=script&lang=ts&setup=true"

import "./CurrencyList.vue?vue&type=style&index=0&id=717c1816&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-717c1816"]])

export default __exports__